import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkComponent } from '@vg-constellation/angular-20/link';
import { ContentUtil } from '../../../../../utils/content/content.util';
import { environment } from 'src/environments/environment';
import { AdobeTagging } from '../../../../../utils/decorators/dev/adobe-launch';
import { adobeConfigData } from './gaf-complete-our-form-mvp-adobe';

@AdobeTagging(adobeConfigData)
@Component({
  selector: 'zci-gaf-complete-our-form-mvp',
  standalone: true,
  imports: [CommonModule, LinkComponent],
  templateUrl: './gaf-complete-our-form-mvp.component.html',
  styleUrls: ['./gaf-complete-our-form-mvp.component.scss']
})
export class GafCompleteOurFormMvpComponent {
  content = this.populateContent();
  environment = environment;

  trackCompleteOurFormLink(): void { }

  private populateContent() {
    const content = ContentUtil.grantorFragmentContent.add_user.frmcSelectUserToGiveAccess.hlpAssociatedControlPersonAccess;
    const cleaned = content.text1
      .replace(/<[^>]+>/g, '')
      .replace(/\n/g, '')
      .trim();

    const placeholder = '${complete-our-form}';
    const noteMatch = cleaned.match(/^Note:/);
    const note = noteMatch ? noteMatch[0] : '';
    const afterNote = cleaned.replace(/^Note:\s*/, '');
    const [preText, postText] = afterNote.split(placeholder);

    return {
      ...content,
      note,
      preText: preText ? preText.trim() : '',
      postText: postText ? postText.trim() : ''
    };
  }
}
